import { Button, Stack } from '@mui/joy';
import { X } from '@phosphor-icons/react';
import { UseFieldArrayReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { corporateLocationService } from 'corporate/services';
import { IPricingProfileAccessForm } from 'pricing/components';
import { Color, Direction, Variant } from 'theme/enums';

interface IProps {
  locations: UseFieldArrayReturn<IPricingProfileAccessForm, 'locations'>;
}

export const LocationsField = ({ locations }: IProps) => {
  const { t } = useTranslation();
  const { control, errors, setValue } = useFormContext();

  const onRemove = (index: number) => {
    if (locations.fields.length === 1) {
      setValue('allLocations', true);
    }

    locations.remove(index);
  };

  return (
    <>
      {locations.fields.map((locationField, index) => (
        <Stack key={locationField.id} direction={Direction.ROW} spacing={1}>
          <FormField
            name={`locations.${index}.location`}
            type={InputType.AUTOCOMPLETE}
            wrapperStyle={{ flex: 1 }}
            inputProps={{
              control,
              error: errors.locations?.[index]?.location,
              placeholder: t('placeholderSelectLocation'),
              getOptions: corporateLocationService.getLocationsAutocomplete,
              disableClearable: true,
            }}
          />
          <Button variant={Variant.PLAIN} color={Color.DANGER} onClick={() => onRemove(index)}>
            <X />
          </Button>
        </Stack>
      ))}
    </>
  );
};
